// dependencies imports ⇒
import React, { useState, useEffect } from "react";
// assets and scss imports ⇒
import "./abhaHealthRecord.scss";
import abhaImg from "../../../assets/Group 28915.png";
import indiaLogo from "../../../assets/national-health-authority-logo-8A35B1DD02-seeklogo.com.png";

// project file imports(UI components) ⇒
import AbhaConsentRequestForm from "./ConsentRequestForm";
import ConsentListMainContainer from "./ConsentListMainContainer";
import ConsentGrantedViewDocuments from "./ConsentGrantedViewDocuments";
import {
  CREATED_AT_OPTIONS,
  GRANTED_AT_OPTIONS,
  REQUEST_STATUS_OPTIONS,
} from "./constant";
import { GET_ABHA_CONSENT } from "./AbhahealthRecordApiHandler/apiConstants";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";
import ComponentSpecificLoader from "../../UI Component/Loader/ComponentSpecificLoader";

// const file imports(helper methods, etc) ⇒

function AbhaHealthRecord(props) {
  // const declarations ⇒
  const { appointmentDetails } = props;

  const [selectedPage, setSelectedPage] = useState("");
  const [requestStatusOptions, setRequestStatusOptions] = useState(
    JSON.parse(JSON.stringify(REQUEST_STATUS_OPTIONS))
  );
  const [createdStatusOptions, setCreatedStatusOptions] = useState(
    JSON.parse(JSON.stringify(CREATED_AT_OPTIONS))
  );
  const [grantedStatusOptions, setGrantedStatusOptions] = useState(
    JSON.parse(JSON.stringify(GRANTED_AT_OPTIONS))
  );

  const [activePage, setActivePage] = useState(1);
  const [consentList, setConsentList] = useState([]);
  const [consentRequestId, setConsentRequestId] = useState("");
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [firstTimeApiCall, setFirstTimeApiCall] = useState(true);
  const clearFilter = selectedPage === 2;

  // let or var declarations ⇒

  // life cycle methods ⇒

  useEffect(() => {
    getAbhaConsentList();
  }, [
    requestStatusOptions,
    createdStatusOptions,
    grantedStatusOptions,
    activePage,
  ]);

  // API Calls ⇒

  const getAbhaConsentList = () => {
    const statusFilter = requestStatusOptions
      .filter((option) => option.selected)
      .map((obj) => obj.value);

    const createdFilter = createdStatusOptions
      .filter((option) => option.selected)
      .map((obj) => obj.value);

    const grantedFilter = grantedStatusOptions
      .filter((option) => option.selected)
      .map((obj) => obj.value);

    let reqPayload = {
      preferred_abha_address: appointmentDetails?.preferred_abha_address,
      page: activePage,
      records_per_page: 10,
      status_filter: !clearFilter ? statusFilter.toString() : "",
      created_at_filter: !clearFilter ? createdFilter.toString() : "",
      granted_at_filter: !clearFilter ? grantedFilter.toString() : "",
      appointment_id: appointmentDetails?.appointment_id,
    };
    setLoader(true);
    const resData = c2cPostApiHandler(GET_ABHA_CONSENT, reqPayload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setLoader(false);
          setConsentList(res?.data?.data);
          setTotalRecordCount(res?.data?.total_count);
          setSelectedPage(
            res?.data?.data.length === 0 && firstTimeApiCall ? 1 : 3
          );
          setFirstTimeApiCall(false);
        } else {
          setLoader(false);
        }
      } else {
        setLoader(false);
      }
    });
  };

  // Helper methods ⇒

  const handleSelectPage = (val) => {
    setSelectedPage(val);
  };

  // Actions ⇒

  // create UI ⇒

  const abhaRequestPatientHealthRecordUI = () => {
    return (
      <div className="arphr-container">
        <div className="arphr-container-heading">
          Connect To Clinic Is Now ABDM Compliant
        </div>
        <div className="arphr-container-pera">
          Experience enhanced healthcare capabilities with the seamless
          integration of Connect2Clinic and Ayushman Bharat Digital Mission
          (ABDM).
        </div>
        <div className="arphr-btn-img-wrapper">
          <div className="arphr-btn" onClick={() => handleSelectPage(2)}>
            <span>Request Patient Health Record</span>
          </div>
          <img className="arphr-image" src={abhaImg} />
        </div>
        <div className="arphr-title-logo-wrapper">
          <div className="arphr-title">APPROVED BY</div>
          <img className="arphr-logo" src={indiaLogo} />
        </div>
      </div>
    );
  };

  //
  return (
    <div className="abha-health-record-container">
      {loader && <ComponentSpecificLoader />}
      {selectedPage === 1 && <div>{abhaRequestPatientHealthRecordUI()}</div>}
      {selectedPage === 2 && (
        <div>
          <AbhaConsentRequestForm
            appointmentDetails={appointmentDetails}
            handleSelectPage={handleSelectPage}
            getAbhaConsentList={getAbhaConsentList}
          />
        </div>
      )}
      {selectedPage === 3 && (
        <div>
          <ConsentListMainContainer
            loader={loader}
            totalRecordCount={totalRecordCount}
            appointmentDetails={appointmentDetails}
            activePage={activePage}
            consentList={consentList}
            setActivePage={setActivePage}
            requestStatusOptions={requestStatusOptions}
            grantedStatusOptions={grantedStatusOptions}
            createdStatusOptions={createdStatusOptions}
            setRequestStatusOptions={setRequestStatusOptions}
            setCreatedStatusOptions={setCreatedStatusOptions}
            setGrantedStatusOptions={setGrantedStatusOptions}
            setConsentRequestId={setConsentRequestId}
            getAbhaConsentList={getAbhaConsentList}
            handleSelectPage={handleSelectPage}
          />
        </div>
      )}
      {selectedPage === 4 && (
        <div>
          <ConsentGrantedViewDocuments
            appointmentDetails={appointmentDetails}
            consentRequestId={consentRequestId}
            handleSelectPage={handleSelectPage}
          />
        </div>
      )}
    </div>
  );
}

export default AbhaHealthRecord;
